import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import config from '../App/config';
import CreateAccount from './createAccount/CreateAccount';
import PaymentPreference from './createAccount/PaymentPreference';
import { EMAIL_VERIFY, PAYMENT_PREFERENCE_PATH, LOOKS_LIKE } from './constants';
import EmailVerify from './verify/EmailVerify';
import LooksLike from './looksLike';

const GuidedReg = () => {
    const basePath = config.pagePaths.guidedRegWorkflow;
    return (
        <Routes>
            <Route path={basePath} element={<CreateAccount />} />
            <Route path={`${basePath}${EMAIL_VERIFY}`} element={<EmailVerify />} />
            <Route path={`${basePath}${PAYMENT_PREFERENCE_PATH}`} element={<PaymentPreference />} />
            <Route path={`${basePath}${LOOKS_LIKE}`} element={<LooksLike />} />
        </Routes>
    );
};

export default memo(GuidedReg);
